import { proxy } from "valtio";
import { Notebook } from "../shared/models/notebook.model";
import { Template } from "../shared/models/templates.model";
import { UseCaseStep } from "../shared/models/useCaseStep.model";
import { Keydates } from "../shared/models/keydates.model";
import { Objective } from "../shared/models/objective.model";
import { Engagement } from "../shared/models/engagement.model";
import { EngagementTeam } from "../shared/models/engagementTeam.model";
import { Affiliate } from "../shared/interfaces/affiliate.interface";
import { Launch } from "../shared/models/launch.model";
import { ClientMetrics } from "../shared/models/clientMetrics.model";
import { Campaign } from "../shared/models/campaign.model";
import { Audience } from "../shared/models/audience.model";
import { EngagementList } from "../shared/models/engagementList.model";

export const engagementStore = proxy({
  teamData: [] as EngagementTeam[],
  affiliates: [] as Affiliate[],
  engagementSelected: new Engagement(),
  engagementList: new EngagementList(),
  objectives: [] as Objective[],
  launches: [] as Launch[],
  showCreateEditor: false,
  todoList: [] as any[],
  providerId: 4, //default value for now
  phaseSelected: "",
  objectiveSelected: {
    id: "",
    name: "",
  },
  launchSelected: {
    id: "",
    name: "",
  },
  engagementData: {
    campaign: new Campaign(),
    audience: new Audience(),
    clientMetrics: new ClientMetrics(),
    keyDates: {
      academic_calendar_url: "",
      dates: [] as Keydates[],
    },
    useCaseSteps: [] as UseCaseStep[],
    useCaseSelected: null as UseCaseStep | null,
    notebooks: [new Notebook()],
    todos: [] as Template[],
    teamMembers: [],
  },
  setNotebooks: (value: Notebook[]) => {
    engagementStore.engagementData.notebooks = value
  },
  setTodoListAction: (value: any[]) => {
    engagementStore.todoList = value
  },
  setEngagementListData: (value: any) => {
    engagementStore.engagementList = value
  },
  selectUseCase: (value: UseCaseStep) => {
    engagementStore.engagementData.useCaseSelected = value
  },
  selectEngagementAction: (value: Engagement) => {
    engagementStore.engagementSelected = value
  },
  setEngagementTeamAction: (value: any) => {
    engagementStore.engagementData.teamMembers = value
  },
  setAffiliatesAction: (value: any) => {
    engagementStore.affiliates = value
  },
  setObjectivesAction: (value: any[]) => {
    engagementStore.objectives = value
  },
  selectObjective: (value: any) => {
    engagementStore.objectiveSelected = value
  },
  selectLaunch: (_: Launch) => {
    // engagementStore.launchSelected = value;
  },
  setEngagementData: (value: any) => {
    engagementStore.engagementData = value
  },
  setEngagementDataAudience: (value: any) => {
    engagementStore.engagementData.audience = value
  },
  setEngagementDataCampaign: (value: any) => {
    engagementStore.engagementData.campaign = value
  },
  setEngagementDataClientMetrics: (value: any) => {
    engagementStore.engagementData.clientMetrics = value
  },
  setEngagementDataKeyDates: (value: any) => {
    //TODO: update academicUrl
    engagementStore.engagementData.keyDates.dates =
      engagementStore.engagementData.keyDates.dates.map((keydate) =>
        keydate.name === value.key
          ? {
              ...keydate,
              value: value.value,
            }
          : keydate
      )
  },
  setEngagementDataAcademicUrl: (value: string) => {
    engagementStore.engagementData.keyDates.academic_calendar_url = value
  },
  deleteEngagementDataKeyDates: (value: string) => {
    engagementStore.engagementData.keyDates.dates =
      engagementStore.engagementData.keyDates.dates.filter(
        (keydate) => keydate.name != value
      )
  },
  addEngagementDataKeyDates: (value: Keydates) => {
    engagementStore.engagementData.keyDates.dates.push(value)
  },
  updateUseCase: (_key: string, value: UseCaseStep) => {
    engagementStore.engagementData.useCaseSteps =
      engagementStore.engagementData.useCaseSteps.map((useCase) =>
        useCase.id === value.id ? value : useCase
      )
  },
  setShowCreateEditor: (value: boolean) => {
    engagementStore.showCreateEditor = value
  },
  setEngagementDataTeamMembers: (value: any) => {
    engagementStore.engagementData.teamMembers = value
  },
  setPhaseSelected: (value: string) => {
    engagementStore.phaseSelected = value
  },
  setLaunchesAction: (value: any[]) => {
    engagementStore.launches = value
  },
  setSelectedEngagement: (value: Engagement) => {
    engagementStore.engagementSelected = value
  },
  setSelectedLaunch: (_: Launch) => {
    // engagementStore.launchSelected = value;
  },
})
